import React from 'react';
import { Box, Heading, Container } from '@chakra-ui/react';
import SEO from '../components/SEO';

export default function Settings() {
  return (
    <>
      <SEO 
        title="Settings"
        description="Manage your application settings"
        path="/settings"
      />
      <Container maxW="container.xl" pt={5}>
        <Box>
          <Heading mb={6}>Settings</Heading>
          {/* Add your settings content here */}
        </Box>
      </Container>
    </>
  );
} 